import React from 'react'
import { View } from 'react-native'
import tw from 'tailwind-rn'

import { BlockMarkdownType } from '../../config/types'
import Markdown from './Markdown'

type Props = {
  data: BlockMarkdownType
}

const BlockMarkdown = (props: Props) => {
  const { data } = props
  const { content } = data

  return (
    <View style={tw('pb-6')}>
      <Markdown>{content}</Markdown>
    </View>
  )
}

export default BlockMarkdown
